@let cartographie = this.cartographie();
@if (cartographie) {
  <div class="flex h-svh flex-col">
    <app-header [cartographie]="cartographie" [filtres]="filtres()" (onFilter)="openFilterPanel()" />

    <section class="m-lg h-full overflow-y-auto bg-white !py-0" hlmCard>
      <div class="!p-lg gap-xl grid" hlmCardContent>
        @for (region of regions() | trierPar: 'nom'; track region.id) {
          <app-expansion-panel [titre]="region.nom" [item]="region">
            <div class="gap-xs ml-auto flex items-center" ngProjectAs="chipRight">
              <app-chip
                [label]="getEtapeNumberParEtatInRegion(region.sites, etatGroupe.VALIDE)"
                icon="lucideCircleCheck"
                variant="positive"
              />
              <app-chip
                [label]="getEtapeNumberParEtatInRegion(region.sites, etatGroupe.A_VALIDER)"
                icon="lucideInfo"
                variant="informative"
              />
              <app-chip
                [label]="getEtapeNumberParEtatInRegion(region.sites, etatGroupe.REJETE)"
                icon="lucideCircleAlert"
                variant="negative"
              />
              <app-chip [label]="getEtapeNumberInRegion(region) | i18nPlural: formationMapping" />
            </div>
            <div class="gap-md p-md grid">
              @for (site of region.sites | trierPar: 'nom'; track site.id) {
                <app-expansion-panel [titre]="site.nom" [item]="site">
                  <div class="gap-xs ml-auto flex items-center" ngProjectAs="chipRight">
                    <app-chip
                      [label]="getEtapeNumberParEtatInSite(site.etapes, etatGroupe.VALIDE)"
                      icon="lucideCircleCheck"
                      variant="positive"
                    />
                    <app-chip
                      [label]="getEtapeNumberParEtatInSite(site.etapes, etatGroupe.A_VALIDER)"
                      icon="lucideInfo"
                      variant="informative"
                    />
                    <app-chip
                      [label]="getEtapeNumberParEtatInSite(site.etapes, etatGroupe.REJETE)"
                      icon="lucideCircleAlert"
                      variant="negative"
                    />
                    <app-chip [label]="site.etapes.length | i18nPlural: formationMapping" />
                  </div>
                  <div class="px-md py-sm">
                    @if (site.etapes.length > 0) {
                      <div class="gap-sm flex flex-col">
                        @if (peutModifier()) {
                          <a class="w-fit" [routerLink]="[site.id]" hlmBtn variant="secondary">
                            <ng-icon name="lucidePlus" />
                            Ajouter des formations au Centre de Formations
                          </a>
                        }
                        <div class="gap-md grid grid-cols-3">
                          @for (etape of site.etapes; track etape.id) {
                            <app-etape-item [cartographie]="cartographie" [etape]="etape" [site]="site" />
                          }
                        </div>
                      </div>
                    } @else {
                      <app-empty-state title="Aucune formation n'a été ajoutée au Centre de Formations">
                        <div class="gap-lg grid">
                          <span class="paragraph-medium-medium text-content-secondary text-center"
                            >Veuillez cliquer sur le bouton ci-dessous pour sélectionner les formations à ajouter à
                            votre Centre de Formations.</span
                          >
                          @if (peutModifier()) {
                            <a class="mx-auto w-fit" [routerLink]="[site.id]" hlmBtn variant="secondary">
                              <ng-icon name="lucidePlus" />
                              Ajouter des formations au Centre de Formations
                            </a>
                          }
                        </div>
                      </app-empty-state>
                    }
                  </div>
                </app-expansion-panel>
              } @empty {
                <span>Pas de CFA dans cette région.</span>
              }
            </div>
          </app-expansion-panel>
        } @empty {
          <app-empty-state title="Aucun élément ne correspond à votre recherche.">
            <div class="gap-lg grid">
              <span class="paragraph-medium-medium text-content-secondary text-center"
                >Vous pouvez modifier votre recherche en cliquant sur le bouton « Filtres » ci-dessus.</span
              >
            </div>
          </app-empty-state>
        }
      </div>
    </section>
  </div>
}
